<div matTooltip>
  <button mat-menu-item (click)="option.action()">
    <dojo-icon *ngIf="option.icon" [class]="state.classes + ' menu-icon'" [icon]="option.icon"></dojo-icon>
    <span [class]="state.classes + ' menu-item-label'">{{ state.label }}</span>
  </button>
</div>
